var render = function render(){
  var _vm$practice, _vm$practice$section, _vm$practice2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "title": "Practice Areas",
            "src": "/images/sub/sub-visual.jpg"
          }
        })];
      },
      proxy: true
    }, {
      key: "contentsImmersive",
      fn: function () {
        return [_c('div', {
          staticClass: "grey"
        }, [_c('v-container', {
          staticClass: "px-0 px-md-12px"
        }, [_c('v-tabs', {
          staticClass: "immersive-tabs",
          attrs: {
            "grow": "",
            "hide-slider": ""
          }
        }, [_c('v-tab', {
          attrs: {
            "to": "/en/practice/corporate"
          }
        }, [_vm._v("Corporate Advisory")]), _c('v-tab', {
          attrs: {
            "to": "/en/practice/dispute"
          }
        }, [_vm._v("Dispute Resolution")])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first pb-0"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm"
  }, [_c('h3', {
    staticClass: "tit tit--xl tit--point line-height-11"
  }, [_c('span', [_vm._v("Corporate Advisory")]), _c('span', {
    staticClass: "tit--point__circle",
    attrs: {
      "data-aos": "zoom-in"
    }
  })])]), _c('div', {
    staticClass: "txt line-height-15 overflow-hidden"
  }, [_c('div', {
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "600"
    },
    domProps: {
      "innerHTML": _vm._s((_vm$practice = _vm.practice) === null || _vm$practice === void 0 ? void 0 : (_vm$practice$section = _vm$practice.section1) === null || _vm$practice$section === void 0 ? void 0 : _vm$practice$section.txt.replace(/\n/gi, '<br/>'))
    }
  })])]), _c('page-section', {
    staticClass: "page-section--sm page-section--last"
  }, [_c('div', {
    staticClass: "pb-16px pb-md-20px"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Key Practice Areas")])]), _c('v-divider', {
    staticClass: "grey darken-4",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-expansion-panels', {
    staticClass: "font-secondary",
    attrs: {
      "flat": "",
      "multiple": ""
    }
  }, _vm._l((_vm$practice2 = _vm.practice) === null || _vm$practice2 === void 0 ? void 0 : _vm$practice2.section2, function (section, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticClass: "pa-12px px-md-20px py-md-24px border-b"
    }, [_c('div', {
      staticClass: "tit tit--xxs font-weight-medium"
    }, [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.title))])]), _c('v-expansion-panel-content', {
      staticClass: "grey lighten-5"
    }, [_c('div', {
      staticClass: "px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b"
    }, [_c('page-section', {
      staticClass: "page-section--xxs py-0",
      scopedSlots: _vm._u([{
        key: "pageSectionImmersive",
        fn: function () {
          return _vm._l(section.columns, function (columns, index) {
            return _c('div', {
              key: index,
              class: {
                'pt-8px pt-md-10px': index != 0
              }
            }, [_c('v-row', {
              staticClass: "row--xs txt txt--sm line-height-15"
            }, [_c('v-col', [_c('v-row', {
              staticClass: "row--xs"
            }, [_c('v-col', {
              attrs: {
                "cols": "auto"
              }
            }, [_vm._v("·")]), _c('v-col', [_c('div', [_vm._v(_vm._s(columns === null || columns === void 0 ? void 0 : columns.txt))])])], 1)], 1)], 1)], 1);
          });
        },
        proxy: true
      }], null, true)
    })], 1)])], 1);
  }), 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }